import { StyleSheet } from "react-native";

/**
 * Mobile-only (iPhone) styles for the Notifications & Comms screen.
 * Applied when Platform.OS === "ios" && windowWidth < 768.
 * Does NOT affect web or iPad.
 */
const mobileNotifStyles = StyleSheet.create({
  /* ── Screen root ─────────────────────────────────────────── */
  screenRoot: {
    flex: 1,
    backgroundColor: "#f0f4fa",
  },

  /* ── Header block ────────────────────────────────────────── */
  headerBlock: {
    backgroundColor: "#ffffff",
    paddingHorizontal: 16,
    paddingVertical: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#ebebeb",
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flex: 1,
  },
  backArrowWrap: {
    padding: 2,
  },
  headerTitleBlock: {
    flex: 1,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: "700",
    color: "#1a2332",
    lineHeight: 26,
  },
  headerSubtitle: {
    fontSize: 12,
    color: "#818181",
    marginTop: 1,
  },
  addIconBtn: {
    padding: 4,
  },

  /* ── Section label ───────────────────────────────────────── */
    sectionLabelRow: {
      paddingHorizontal: 16,
      paddingTop: 10, // reduced from 16
      paddingBottom: 4, // reduced from 8
    },
  sectionLabel: {
    fontSize: 11,
    fontWeight: "700",
    color: "#818181",
    letterSpacing: 0.7,
  },

  /* ── Card list ───────────────────────────────────────────── */
  cardList: {
    paddingHorizontal: 16,
    paddingBottom: 20, // reduced from 32
  },

  /* ── Card ────────────────────────────────────────────────── */
  card: {
    backgroundColor: "#ffffff",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#e6edf8",
    marginBottom: 12,
    overflow: "hidden",
    position: "relative",
  },
  cardPressed: {
    opacity: 0.85,
  },
  cardLeftBorder: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  cardContent: {
    paddingLeft: 16,
    paddingRight: 12,
    paddingTop: 12,
    paddingBottom: 0,
  },

  /* Top row: title + three-dots */
  cardTopRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 8,
    marginBottom: 6,
  },
  cardTitle: {
    flex: 1,
    fontSize: 15,
    fontWeight: "700",
    color: "#1a2332",
    lineHeight: 21,
  },
  moreBtn: {
    padding: 4,
  },

  /* Badge row */
  badgeRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
    marginBottom: 8,
  },
  badge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    borderRadius: 100,
    paddingHorizontal: 9,
    paddingVertical: 4,
  },
  badgeDot: {
    width: 7,
    height: 7,
    borderRadius: 4,
  },
  badgeText: {
    fontSize: 12,
    fontWeight: "600",
  },

  /* Badge colour variants */
  badgeIncident: { backgroundColor: "#FFE5DE" },
  badgeIncidentText: { color: "#C12C01" },
  badgeIncidentDot: { backgroundColor: "#C12C01" },
  badgeMaint: { backgroundColor: "#DAEEFA" },
  badgeMaintText: { color: "#034895" },
  badgeMaintDot: { backgroundColor: "#034895" },
  badgeGeneral: { backgroundColor: "#EBEBEB" },
  badgeGeneralText: { color: "#4b4b4b" },
  badgeGeneralDot: { backgroundColor: "#838383" },
  badgeAuto: { backgroundColor: "#E8F0FB" },
  badgeAutoText: { color: "#034895" },

  /* Card message */
  cardMessage: {
    fontSize: 13,
    color: "#4b4b4b",
    lineHeight: 19,
    marginBottom: 10,
  },

  /* Card meta row */
  cardMetaRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 12,
  },
  cardMetaItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  cardMetaText: {
    fontSize: 11,
    color: "#818181",
  },

  /* Stats row (Delivered / Seen / Open rate) */
  cardDivider: {
    height: 1,
    backgroundColor: "#ebebeb",
    marginHorizontal: -12,
    marginBottom: 0,
  },
  cardStatsRow: {
    flexDirection: "row",
    paddingVertical: 10,
  },
  cardStat: {
    flex: 1,
    alignItems: "flex-start",
  },
  cardStatNum: {
    fontSize: 15,
    fontWeight: "700",
    color: "#2d2d2d",
    lineHeight: 20,
  },
  cardStatLabel: {
    fontSize: 11,
    color: "#818181",
    marginTop: 1,
  },
});

/** Left accent border colour per notification type */
export const NOTIF_BORDER_COLOR: Record<string, string> = {
  incident: "#C12C01",
  maint: "#005CBC",
  general: "#838383",
};

export default mobileNotifStyles;
